export enum CommunicationsPanelAvailabilityStart {
  InDraft = 1,
  AfterFormSubmission = 2,
}